export const isPreferReducedMotion = () => {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
